import React, { useEffect, useState } from 'react';
import { contentApi } from '../../services/contentApi';
import { AuthorCard as Author } from '../../types/content';
import AuthorCard from '../../components/content/AuthorCard';

const AuthorsPage: React.FC = () => {
  const [authors, setAuthors] = useState<Author[]>([]);
  useEffect(() => {
    contentApi.listAuthors().then((r) => setAuthors(r.data.authors || [])).catch(() => undefined);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold">Authors</h1>
      <p className="mt-2 text-gray-600">Identity still lives in the shared Authorization service. This list is derived from content creators.</p>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {authors.map((author) => <AuthorCard key={author.authorId} author={author} />)}
      </div>
    </div>
  );
};

export default AuthorsPage;
